import { render, staticRenderFns } from "./MarketOrder.vue?vue&type=template&id=b54bd006&"
import script from "./MarketOrder.vue?vue&type=script&lang=js&"
export * from "./MarketOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports